import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useSelector } from 'react-redux';

/**
 * Primary UI component for user interaction
 */
export const Carousel = ({ data, classes, ...props }) => {
    const { layout } = useSelector((state) => state.layout);
    const isPopup = layout === 'popup';
    const carouselSetting = {
        infinite: false,
        dots: props.dot,
        arrows: props.arrows,
        speed: 500,
        responsive: [
            {
                breakpoint: 9999,
                settings: 'unslick',
            },
            {
                breakpoint: 1390,
                settings: isPopup
                    ? {
                          slidesToShow: 3.07,
                          slidesToScroll: 1,
                      }
                    : 'unslick',
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.07,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1.07,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div className={['card-carousel-container', 'w-full h-full', classes && classes].join(' ')}>
            <Slider
                className={`card-carousel flex items-center ${
                    data?.length > 3 ? 'justify-center' : 'justify-start'
                } gap-2 md:flex-wrap`}
                {...carouselSetting}>
                {data.map((item, index) => (
                    <div
                        key={`Slider-${Math.random() + index}`}
                        className="carousel-item pr-4 grow w-full h-auto md:mr-0 md:max-w-[276px]">
                        {item}
                    </div>
                ))}
            </Slider>
        </div>
    );
};

Carousel.propTypes = {
    /**
     * This is all our carousel array items
     */
    data: PropTypes.array,
};

Carousel.defaultProps = {
    data: [],
};
